import { getApplicationSettings } from 'owa-application-settings';

export function isSmimeCertificatesEnabled(): boolean {
    return getApplicationSettings('LivePersonaEditor').enableSmimeCertificates;
}
